module.exports = __webpack_public_path__ + "img/broken-camera.cf112674.svg";